export const predefTags = [
  "Appetizers",
  "Breakfast",
  "Main Course",
  "Desserts",
  "Snacks",
  "Asian",
  "Vegetarian",
  "Western",
  "Baking",
  "Chicken",
  "Comfort Food",
  "Dairy-Free",
  "Low-Carb",
  "Gluten-Free",
  "Healthy",
  "Quick & Easy",
  "Grilled",
  "Pasta",
  "Salads",
  "Seafood",
  "Soups",
  "Vegan",
]